/**
 * Osteo3d brand logo component.
 *
 * Usage:
 *   <OsteoLogo />                  — default size
 *   <OsteoLogo size="sm" />        — smaller (e.g. headers)
 *   <OsteoLogo size="lg" />        — larger (e.g. landing page)
 *
 * Source image: frontend/public/osteo3d-logo.png
 */
const HEIGHT = { sm: 36, md: 52, lg: 72 }

export default function OsteoLogo({ size = 'md' }) {
  const h = HEIGHT[size] ?? HEIGHT.md
  return (
    <img
      src="/osteo3d-logo.png"
      alt="Osteo3d — 3d printing healthcare"
      height={h}
      style={{ height: h, width: 'auto', display: 'block' }}
    />
  )
}
